'use client';

import { ConditionalWrapper } from '@packages/shared/src/ui/ConditionalWrapper/ConditionalWrapper';
import { cva } from 'class-variance-authority';
import clsx from 'clsx';
import { useRef } from 'react';
import { LinkWrapper } from './components/LinkWrapper.client';
import { MainHeadline } from './components/MainHeadline.client';
import { SubHeadline } from './components/SubHeadline.client';
import type { HeadlineProps } from './types';

const headlineStyles = cva('mx-0', {
  variants: {
    marginVariant: {
      big: 'my-[1.5rem]',
      medium: 'my-[0.75rem]',
      small: 'my-[0.25rem]',
      none: 'my-0',
    },
  },
});

export const CmsHeadline = ({ data, className }: HeadlineProps) => {
  const {
    field_margin_variant: marginVariant = 'none',
    behavior_paragraph_outer_spacing: margin,
    field_link: fieldLink,
    field_text_subheadline: subHeadlineText,
    field_tracking: tracking,
  } = data;

  const headlineRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={headlineRef}
      className={clsx(className, headlineStyles({ marginVariant }))}
      style={{ margin }}
      data-tracking={tracking}
    >
      <ConditionalWrapper condition={!!fieldLink} wrapper={LinkWrapper({ data, headlineRef })}>
        <>
          <MainHeadline data={data} />
          {subHeadlineText && <SubHeadline data={data} />}
        </>
      </ConditionalWrapper>
    </div>
  );
};
